import React, {Component} from 'react';
import {connect} from 'react-redux';
import LoadingIcon from 'Components/icons/LoadingIcon';
import util from 'Utils/commonUtil';
import {loadLanguage} from 'Utils/jwtUtil';
// Components
import {Grid, IconButton} from '@material-ui/core';
import Anchor from 'Components/common/Anchor';
import BaseImageUploader from 'Components/common/BaseImageUploader';
import BasicButton from 'Components/common/BasicButton';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import Dialog from 'Components/common/Dialog';
import Tag from 'Components/common/Tag';

// Actions
import {
    getAbnormalRecordList,
    uploadReceiveImage,
    scrapUpload,
    previewTagUploadImage,
} from 'Actions/host';
import {openNotification} from 'Actions/notification';

// Icons
import {ArrowBackIos} from '@material-ui/icons';
import {T} from 'Actions/translate';

class AbnormalRecordList extends Component {
    pager = {
        page: 0,
        length: 10,
        pageTotal: 9999999999999999999999999,
        total: 0,
    };

    state = {
        pageLoad: true,
        listLoaded: true,
        imageStream: {},
        abnormalUploadDialogOpened: false,
        previewImageDialogOpened: false,
        chooseImage: null,
        loading: false,
        currentCardId: null,
    };

    componentWillMount() {
        this.getAbnormalRecordList(false);
    }

    getAbnormalRecordList = (reload) => {
        if (this.pager.page >= this.pager.pageTotal) return;

        this.setState({listLoaded: false});

        const params = {
            orderBy: 'id',
            orderByColumn: 'id',
            isAsc: 'desc',
            pageNum: reload ? 1 : this.pager.page + 1,
            pageSize: this.pager.length,
        };

        this.props
            .getAbnormalRecordList(params)
            .then((res) => {
                this.pager.page = res.pageNum;
                this.pager.total = res.total;
                this.pager.pageTotal = res.pageTotal;
                this.setState({pageLoad: false, listLoaded: true});
            })
            .catch((res) => {
                this.setState({
                    listLoaded: true,
                    pageLoad: false,
                });
            });
    };

    goToAdd = () => {
        this.props.history.replace('/abnormalRecordSave');
    };

    abnormalUploadHandle = (id) => {
        this.setState({
            currentCardId: id,
            abnormalUploadDialogOpened: true,
        });
    };

    dialogDidClose = (dialog) =>
        this.state[dialog] && this.setState({[dialog]: false});

    chooseImage = (item) =>
        this.refs['inputFile'] && this.refs['inputFile'].click();

    selectedImage = (ev) => {
        if (!ev.target.files && !ev.target.files[0]) return;
        if (!/^image\//.test(ev.target.files[0].type)) {
            return this.props.openNotification(
                T('notification_please_select_picture'),
                'danger',
            );
        }
        const reader = new FileReader();
        const file = ev.target.files[0];

        reader.onload = (ev) => {
            this.setState({chooseImage: {file, url: ev.target.result}});
        };

        reader.readAsDataURL(file);
    };

    previewTagImage = (item) => {
        this.props
            .previewTagUploadImage(
                {path: item['pic'], id: item['id']},
                'Scrap Image',
            )
            .then((res) => {
                if (this.props.previewData) {
                    this.setState(
                        {
                            previewImageDialogOpened: true,
                            imageStream: this.props.previewData,
                        },
                        () => {
                            let img = new Image();
                            img.src = this.props.previewData;
                            img.id = 'adventImage';

                            if (document.getElementById('adventImage')) {
                                document.getElementById('adventImage').remove();
                            }
                            document
                                .getElementById('testImage')
                                .appendChild(img);
                        },
                    );
                }
            })
            .catch((res) => {
                console.log(res);
            });
    };

    uploadConfirmHandle = () => {
        const {currentCardId} = this.state;
        this.setState({
            loading: true,
        });
        if (this.state.chooseImage) {
            this.props
                .uploadReceiveImage({
                    type: 'abnormal',
                    file: this.state.chooseImage.file,
                })
                .then((res) => {
                    if (res['status'] === 'success') {
                        let params = {
                            id: currentCardId,
                            path: res['url'],
                        };
                        this.setState({
                            imageStream: res['url'],
                        });
                        this.props
                            .scrapUpload(params)
                            .then((res) => {
                                if (res['status'] === 'success') {
                                    this.setState({
                                        abnormalUploadDialogOpened: false,
                                        chooseImage: null,
                                        loading: false,
                                    });
                                    this.getAbnormalRecordList(true);
                                    this.props.openNotification(
                                        T('notification_successfully_upload'),
                                        'success',
                                    );
                                }
                            })
                            .catch(() => {
                                this.setState({loading: false});
                            });
                    }
                })
                .catch((e) => {
                    this.setState({loading: false});
                    this.props.openNotification(
                        T('notification_picture_upload_failed'),
                        'danger',
                    );
                });
        } else {
            this.setState({
                loading: false,
            });
            this.props.openNotification(
                T('host_advent_products_upload_tag_is_not_null'),
                'danger',
            );
        }
    };

    render() {
        const {abnormalRecordList} = this.props;
        const {
            listLoaded,
            imageStream,
            abnormalUploadDialogOpened,
            previewImageDialogOpened,
            chooseImage,
            loading,
        } = this.state;
        let lang = loadLanguage();
        return (
            <div className="abnormal-record" testid="scc-abnormal-record-list">
                <Grid
                    className="ship-to-head container-max-width is-fixed"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="back-icon" item xs={3}>
                        <Anchor
                            onClickOfSingleTap={() =>
                                this.props.history.replace('/userCenter')
                            }>
                            <IconButton color="inherit">
                                <ArrowBackIos />
                            </IconButton>
                        </Anchor>
                    </Grid>

                    <Grid
                        className={util.getClassName({
                            'page-title': true && lang !== 'EN',
                            'en-page-title': true && lang === 'EN',
                        })}
                        item
                        xs={9}>
                        <span>{T('host_abnormal_record')}</span>
                    </Grid>
                </Grid>

                {this.state.pageLoad ? (
                    <LoadingIcon className="circle-animation abnormal-load" />
                ) : (
                    <ScrollWrapper
                        showLoadingMore={!listLoaded}
                        showAbyss={this.pager.page >= this.pager.pageTotal}
                        getMoreData={() => {
                            this.getAbnormalRecordList(false);
                        }}
                        listLoaded={listLoaded}>
                        <div className="content">
                            {abnormalRecordList && abnormalRecordList.length > 0
                                ? abnormalRecordList.map((item, i) => {
                                      return (
                                          <section
                                              key={i}
                                              className="content-box"
                                              testid="scc-abnormal-record-row"
                                              data-record-id={item.id}>
                                              <Grid
                                                  container
                                                  spacing={0}
                                                  justify={'center'}>
                                                  <Grid
                                                      className="abnormal-record-top"
                                                      item
                                                      xs={12}
                                                      testid="scc-abnormal-record-number"
                                                      data-record-number={item.id}>
                                                      <div
                                                          className="abnormal-record-top-infor abnormal-record-top-infor-sku"
                                                          testid="scc-abnormal-record-sku-cell">
                                                          {item.kitDisplay}
                                                      </div>
                                                      {
                                                          <div
                                                              className="abnormal-record-top-infor-tag"
                                                              testid="scc-abnormal-record-status-cell">
                                                              {item.approveFlag ===
                                                              1 ? (
                                                                  <Tag
                                                                      className="tag abnormal-record-tag-r"
                                                                      testid="scc-abnormal-record-status"
                                                                      value={T(
                                                                          `host_abnormal_approved`,
                                                                      )}
                                                                      size="6rem"
                                                                  />
                                                              ) : item.approveFlag ===
                                                                2 ? (
                                                                  <Tag
                                                                      className="tag abnormal-record-tag-b"
                                                                      testid="scc-abnormal-record-status"
                                                                      value={T(
                                                                          `host_abnormal_rejected`,
                                                                      )}
                                                                      size="6rem"
                                                                  />
                                                              ) : (
                                                                  <Tag
                                                                      className="tag abnormal-record-tag-y"
                                                                      testid="scc-abnormal-record-status"
                                                                      value={T(
                                                                          `host_abnormal_pending_approval`,
                                                                      )}
                                                                      size="6rem"
                                                                  />
                                                              )}
                                                          </div>
                                                      }
                                                  </Grid>
                                                  <Grid
                                                      className="abnormal-record-top-line"
                                                      item
                                                      xs={12}>
                                                      <div className="abnormal-record-infor abnormal-record-infor-left">
                                                          <span className="abnormal-record-infor-title">
                                                              {T(
                                                                  'host_advent_products_lot',
                                                              )}
                                                          </span>
                                                          {item.lotNo}
                                                      </div>
                                                      <div className="abnormal-record-infor abnormal-record-infor-right">
                                                          <span className="abnormal-record-infor-title">
                                                              {T(
                                                                  'host_product_specifications',
                                                              )}
                                                              :
                                                          </span>
                                                          {item.specifications}
                                                      </div>
                                                  </Grid>
                                                  <Grid
                                                      className="abnormal-record-top-line"
                                                      item
                                                      xs={12}>
                                                      <div className="abnormal-record-infor abnormal-record-infor-left">
                                                          <span className="abnormal-record-infor-title">
                                                              {T(
                                                                  'host_advent_products_type',
                                                              )}
                                                          </span>
                                                          <span testid="scc-abnormal-record-category-cell">
                                                              {item.scrapLabel}
                                                          </span>
                                                      </div>
                                                      <div className="abnormal-record-infor">
                                                          <span className="abnormal-record-infor-title">
                                                              {T(
                                                                  'host_advent_products_expired_quantity',
                                                              )}
                                                          </span>
                                                          <span testid="scc-abnormal-record-quantity-cell">
                                                              {item.quantity}
                                                          </span>
                                                      </div>
                                                  </Grid>
                                                  {item.type === 'REFUND' ? (
                                                      <Grid
                                                          className="abnormal-record-top-line"
                                                          item
                                                          xs={12}>
                                                          <div className="abnormal-record-infor abnormal-record-infor-left">
                                                              <span className="abnormal-record-infor-title">
                                                                  {T(
                                                                      'host_advent_products_f1Number',
                                                                  )}
                                                              </span>
                                                              {item.eoneNumber}
                                                          </div>
                                                          <div className="abnormal-record-infor">
                                                              <span className="abnormal-record-infor-title">
                                                                  {T(
                                                                      'host_advent_products_expressNumber',
                                                                  )}
                                                              </span>
                                                              {
                                                                  item.expressNumber
                                                              }
                                                          </div>
                                                      </Grid>
                                                  ) : null}
                                                  <Grid
                                                      item
                                                      xs={12}
                                                      className="abnormal-record-top-line">
                                                      <div className="abnormal-record-infor abnormal-record-infor-left">
                                                          <span className="abnormal-record-infor-title">
                                                              {T(
                                                                  'host_abnormal_exception_specification_colon',
                                                              )}
                                                          </span>
                                                          {
                                                              item.abnormalDescription
                                                          }
                                                      </div>
                                                      <div className="abnormal-record-infor">
                                                          <span className="abnormal-record-infor-title">
                                                              {T(
                                                                  'host_advent_products_expiration_date',
                                                              )}
                                                          </span>
                                                          {item.expireDate}
                                                      </div>
                                                  </Grid>
                                                  <Grid item xs={12}>
                                                      <div className="abnormal-record-infor">
                                                          <span className="abnormal-record-infor-title">
                                                              {T(
                                                                  'approvalDescription',
                                                              )}
                                                              :
                                                          </span>
                                                          {
                                                              item.approveDescription
                                                          }
                                                      </div>
                                                  </Grid>
                                                  <Grid
                                                      item
                                                      xs={12}
                                                      className="abnormal-record-top-line">
                                                      <div className="abnormal-record-infor abnormal-record-infor-left">
                                                          <span className="abnormal-record-infor-title">
                                                              {T(
                                                                  'host_advent_abnormal_label',
                                                              )}
                                                              :
                                                          </span>
                                                          {item.createTime}
                                                      </div>
                                                      <div className="abnormal-record-infor abnormal-record-infor-btn">
                                                          {item.approveFlag !==
                                                              1 &&
                                                          item.approveFlag !==
                                                              2 ? (
                                                              <Anchor
                                                                  className="tag-upload abnormal-record-infor-btn-showpic bnormal-record-infor-btn-red "
                                                                  onClickOfSingleTap={() => {
                                                                      this.abnormalUploadHandle(
                                                                          item.id,
                                                                      );
                                                                  }}>
                                                                  {T(
                                                                      'shippment_upload_again',
                                                                  )}
                                                              </Anchor>
                                                          ) : null}
                                                          <Anchor
                                                              className="bnormal-record-infor-btn-red"
                                                              scr={imageStream}
                                                              onClickOfSingleTap={() =>
                                                                  this.previewTagImage(
                                                                      item,
                                                                  )
                                                              }>
                                                              {T(
                                                                  'shippment_preview',
                                                              )}
                                                          </Anchor>
                                                      </div>
                                                  </Grid>
                                                  <Grid
                                                      className="abnormal-record-top-line"
                                                      item
                                                      xs={12}>
                                                      <div className="abnormal-record-infor">
                                                          <span className="abnormal-record-infor-title">
                                                              {T(
                                                                  'backup_supply_center',
                                                              )}
                                                              :
                                                          </span>
                                                          {item.scName}
                                                      </div>
                                                  </Grid>
                                              </Grid>
                                          </section>
                                      );
                                  })
                                : null}
                        </div>
                    </ScrollWrapper>
                )}

                <Grid
                    className="page-bottom-container container-max-width is-fixed"
                    container
                    spacing={0}
                    justify={'space-evenly'}>
                    <Grid className="save-button" item xs={11}>
                        <BasicButton
                            type="primary"
                            onClickOfSingleTap={this.goToAdd}>
                            <span>{T('host_abnormal_add')}</span>
                        </BasicButton>
                    </Grid>
                </Grid>

                <Dialog
                    opened={abnormalUploadDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('abnormalUploadDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="upload-image-dialog">
                        <h5 className="upload-method-title text-center">
                            {T('host_advent_products_confirm_upload_tag')}
                        </h5>
                        <div className="tag-upload-dialog-desc text-center">
                            <BaseImageUploader
                                className={util.getClassName({
                                    'upload-method-upload text-center':
                                        true && lang !== 'EN',
                                    'en-upload-method-upload text-center':
                                        true && lang === 'EN',
                                })}
                                onClickOfSingleTap={this.chooseImage}>
                                {chooseImage && chooseImage.url ? (
                                    <img src={chooseImage.url} alt="" />
                                ) : (
                                    <>
                                        <span className="upload-method-upload-icon" />
                                        <span className="upload-method-upload-text">
                                            {T('host_abnormal_upload_here')}
                                        </span>
                                    </>
                                )}
                                <input
                                    ref="inputFile"
                                    type="file"
                                    accept="image/*"
                                    onChange={this.selectedImage}
                                />
                            </BaseImageUploader>
                        </div>
                        <div className="upload-method-actions">
                            <BasicButton
                                type="primary"
                                className="upload-method-submit"
                                loading={loading}
                                onClickOfSingleTap={this.uploadConfirmHandle}>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                className="upload-method-cancel"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'abnormalUploadDialogOpened',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
                <Dialog
                    opened={previewImageDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('previewImageDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="tag-preview-dialog">
                        <p id="testImage" className="text-center"></p>
                        <div className="tag-preview-btn-container">
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'previewImageDialogOpened',
                                    )
                                }>
                                {T('shopping_cart_close')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        abnormalRecordList: host.abnormalRecordList,
        previewData: host.previewData,
    };
};

const mapDispatchToProps = {
    getAbnormalRecordList,
    uploadReceiveImage,
    scrapUpload,
    openNotification,
    previewTagUploadImage,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbnormalRecordList);
